import React from 'react'

function Footer() {
  return (
    <>
    <footer>
        <div className='container'>
            <div className='row'>
                <div className='col-12 col-lg-10 mx-auto'>
                    <div className='row'>
                        <div className='col-6 col-lg-3'>
                            <h2>Company</h2>
                            <ul>
                                <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                            </ul>
                        </div>

                        <div className='col-6 col-lg-3'>
                            <h2>Support</h2>
                            <ul>
                                <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                            </ul>
                        </div>

                        <div className='col-6 col-lg-3'>
                            <h2>Service</h2>
                            <ul>
                                <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                                 <li>About
                                    <a href='#'></a>
                                </li>
                            </ul>
                        </div>

                        <div className='col-6 col-lg-3'>
                            <h2>Follow Us</h2>
                            <div className='row'>
                                <div className='col-3 mx-auto'>
                                    <a href="https://twitter.com/this_is_njoshi">
                                        <img className='footerimg' src='https://www.freeiconspng.com/uploads/logo-twitter-circle-png-transparent-image-1.png'></img>
                                    </a>
                                </div>

                                <div className='col-3 mx-auto'>
                                    <a href="https://www.youtube.com/@NikhilJoshi09/videos">
                                        <img className='footerimg' src='https://cdn.icon-icons.com/icons2/1211/PNG/512/1491580651-yumminkysocialmedia28_83061.png'></img>
                                    </a>
                                </div>

                                <div className='col-3 mx-auto'>
                                    <a href="https://www.linkedin.com/in/nikhiljoshi09/">
                                        <img className='footerimg' src='https://static-00.iconduck.com/assets.00/linkedin-icon-1024x1024-z5dvl47c.png'></img>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className='mt-5'>
                        <p className='main-hero-para text-center w-100'>
                            Copyright @ 2023 NikhilPay. All Rights Reserved
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    </>
  )
}

export default Footer